/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

// Lightbox default options, applied once right after fancybox.js loads
// (fancybox is loaded on demand by window.loadFancybox in utilities).
// https://fancyapps.com/fancybox/3/docs/#options
window.setupFancyboxDefaults = function () {
  if (window.fancyboxDefaultsApplied || !$.fancybox) {
    return;
  }
  window.fancyboxDefaultsApplied = true;
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };
};

// Resize-on-image-load patch for Flickity, applied once right after
// flickity.js loads (flickity is loaded on demand by window.loadFlickity in
// utilities). Must run before any slider is initialized.
window.setupFlickityPatch = function () {
  if (window.flickityPatchApplied || !window.Flickity) {
    return;
  }
  window.flickityPatchApplied = true;
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };
};
document.addEventListener('DOMContentLoaded', function () {
  window.utils.enableDisclosure();

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
 window.collectionSidebarFilter.init();
window.cart.init();


window.map.init();

  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Fancybox is loaded on demand via window.loadFancybox() (see utilities'
  // vendor script loader). Start fetching right away when this page can show
  // a lightbox, so it's ready before the user interacts.
  if (document.querySelector('[data-fancybox], .lightbox[rel="gallery"], [rel=gallery], .js-product-gallery') || window.PXUTheme.theme_settings.quick_shop_enabled || window.PXUTheme.theme_settings.newsletter_popup) {
    window.loadFancybox().then(() => {
      // backwards compatibility with custom lightboxes
      $('.lightbox[rel="gallery"]').fancybox();
    });
  }

  // Sliders visible on the page request Flickity themselves during init.
  // Quick shop galleries only need it once a quick shop is opened, so start
  // fetching early when the page has quick shop links.
  if (document.querySelector('.js-quick-shop-link')) {
    window.loadFlickity();
  }

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  if (document.querySelector('.slider, .flexslider')) {
    window.loadFlickity().then(() => {
      $('.slider, .flexslider').find('li').unwrap();
      $('.slider, .flexslider').flickity({
        pageDots: window.usePageDots,
        imagesLoaded: true,
        arrowShape: window.arrowSize,
        lazyLoad: 2
      });
    });
  }
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  window.swapCardImage = function (thumbnailEl, imageUrl) {
    if (!thumbnailEl || !imageUrl) return;
    const cardImage = thumbnailEl.querySelector('.image__container img:not(.secondary)');
    if (!cardImage) return;
    cardImage.setAttribute('src', imageUrl);
    cardImage.setAttribute('srcset', imageUrl);
  };
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.kit-swatch[data-image]', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.collection_swatches .kit-swatch[data-image]', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          window.swapCardImage($(this).parents('.thumbnail')[0], $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }
          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
       } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
  // Refreshes cart if inventory is available
  sessionStorage.setItem('cartReconciliationPending', 'true');
  refreshCart(data);
} else {
  refreshCart(data);
}
      }
    });
  }
  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  // Rapid quantity changes fire overlapping refreshes. Abort drops the request;
  // the id catches a response that landed before the abort could apply.
 // Reconcile Shopify cart state before rendering.
// Magical Fees can add/remove Production Setup after the initial cart update.
let cartRefreshRequest = null;
let cartRefreshId = 0;

function getLatestCart() {
  return $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false
  });
}

function cartStateSignature(cart) {
  return JSON.stringify({
    item_count: cart.item_count,
    total_price: cart.total_price,
    total_discount: cart.total_discount,
    items: cart.items.map(function(item) {
      return {
        key: item.key,
        id: item.id,
        quantity: item.quantity,
        price: item.price,
        properties: item.properties || {}
      };
    })
  });
}

function waitForStableCart(maxAttempts) {
  maxAttempts = maxAttempts || 8;

  let previousSignature = null;
  let stableCount = 0;
  let attempt = 0;

  function check() {
    attempt++;

    return getLatestCart().then(function(cart) {
      const signature = cartStateSignature(cart);

      if (signature === previousSignature) {
        stableCount++;
      } else {
        stableCount = 0;
        previousSignature = signature;
      }

      // Require two consecutive identical cart states.
      if (stableCount >= 1) {
        return cart;
      }

      if (attempt >= maxAttempts) {
        return cart;
      }

      return new Promise(function(resolve) {
        setTimeout(resolve, 300);
      }).then(check);
    });
  }

  return check();
}

function renderMiniCart(cart) {
  $('.cart_count').empty();

  const $cartBtn = $('.cart_count');
  const value = $cartBtn.text() || '0';
  const $cartForm = $('[data-cart-form]');

  $cartForm.data('total-discount', cart.total_discount);
  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count === 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $cartForm.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cartForm.removeClass('hidden');
  }

  const isCartPage = window.location.pathname === '/cart';

  /*
   * FULL CART PAGE
   *
   * Fetch the actual /cart HTML instead of relying on the
   * Shopify section around the cart form.
   */
  if (isCartPage) {
    const cartUrl =
      `${window.Shopify.routes.root}cart?cart_refresh=${Date.now()}`;

    return fetch(cartUrl, {
      cache: 'no-store'
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error(
            `Cart page request returned ${response.status}`
          );
        }

        return response.text();
      })
      .then(function(html) {
        const rendered = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        [
          '.js-cart_items',
          '.js-cart_discounts',
          '.js-cart_subtotal',
          '.js-cart_savings'
        ].forEach(function(selector) {
          const source = rendered.querySelector(selector);
          const target = document.querySelector(selector);

          if (!source || !target) {
            return;
          }

          target.innerHTML = source.innerHTML;
        });

        if (
          window.PXUTheme.currency.show_multiple_currencies
        ) {
          window.currencyConverter.convertCurrencies();
        }
      })
      .catch(function(error) {
        console.error(
          'Could not refresh the full cart.',
          error
        );
      });
  }

  /*
   * CART DRAWER
   *
   * Keep the existing drawer rendering logic unchanged.
   */
  const $targetCartForms = $cartForm.filter(
    '[data-cart-form="mini-cart"]'
  );

  const $targetCartSection =
    $targetCartForms.closest('.shopify-section');

  if (!$targetCartSection.length) {
    return Promise.resolve();
  }

  const sectionId = $targetCartSection.attr('id').replace(
    'shopify-section-',
    ''
  );

  if (cartRefreshRequest) {
    cartRefreshRequest.abort();
  }

  cartRefreshRequest = new AbortController();
  cartRefreshId += 1;

  const refreshId = cartRefreshId;

  return fetch(
    `${window.Shopify.routes.root}?section_id=${sectionId}`,
    {
      signal: cartRefreshRequest.signal
    }
  )
    .then(function(response) {
      if (!response.ok) {
        throw new Error(
          `Section request returned ${response.status}`
        );
      }

      return response.text();
    })
    .then(function(html) {
      if (refreshId !== cartRefreshId) {
        return;
      }

      const rendered = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      [
        '.js-cart_items',
        '.js-cart_discounts',
        '.js-cart_subtotal',
        '.js-cart_savings'
      ].forEach(function(selector) {
        const source = rendered.querySelector(selector);

        if (!source) {
          return;
        }

        $targetCartForms
          .find(selector)
          .html(source.innerHTML);
      });

      if (
        window.PXUTheme.currency.show_multiple_currencies
      ) {
        window.currencyConverter.convertCurrencies();
      }
    })
    .catch(function(error) {
      if (error.name === 'AbortError') {
        return;
      }

      console.error(
        'Could not refresh the cart.',
        error
      );
    });
}

function refreshCart(cart) {
  setCartUpdating(true);

  // Render the cart immediately
  return renderMiniCart(cart)
    .then(function() {

      // Give Magical Fees time to add Production Setup
      return new Promise(function(resolve) {
        setTimeout(resolve, 1000);
      });

    })
    .then(function() {

      // Now check until the cart is stable
      return waitForStableCart(8);

    })
   .then(function (latestCart) {
  return renderMiniCart(latestCart).then(function () {
    // Sync Production Setup directly from the final Shopify cart state
    latestCart.items.forEach(function (item) {
      if (item.product_title !== 'Production Setup') return;

      var cartItem = document.querySelector(
        '[data-variant-id="' + item.id + '"]'
      );

      if (!cartItem) return;

      var priceElement = cartItem.querySelector('.price');
      var totalElement = cartItem.querySelector('.price_total');

      if (priceElement) {
        priceElement.innerHTML = formatMoney(item.final_price);
      }

      if (totalElement) {
        totalElement.innerHTML = formatMoney(item.original_line_price);
      }
    });
  });
})
    .then(function() {

      return new Promise(function(resolve) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            resolve();
          });
        });
      });

    })
    .then(function() {
      setCartUpdating(false);
    })
    .catch(function(error) {
      console.error('Cart reconciliation failed:', error);
      setCartUpdating(false);
      throw error;
    });
}
// Debounce rapid quantity changes so only the final intended quantity
// is sent to Shopify.
const quantityUpdateTimers = {};

$('body').on('change', '[data-cart-quantity-input]', function () {
  console.log('QUANTITY CHANGE FIRED', $(this).val());

  const $input = $(this);
  const $cartItem = $input.parents('[data-cart-item]');
  const lineID = $cartItem.data('line-id');

  const cartItem = {
    lineID: lineID,
    variantID: $cartItem.data('variant-id'),
    quantity: $input.val(),
    parentCartForm: $input.parents('[data-cart-form]'),
    totalDiscount: $input.parents('[data-cart-form]').data('total-discount'),
    $element: $cartItem
  };

  // Keep checkout/reconciliation locked while the final quantity
  // is waiting to be submitted.
  setCartUpdating(true);

  // Cancel the previous pending update for this cart line.
  if (quantityUpdateTimers[lineID]) {
    clearTimeout(quantityUpdateTimers[lineID]);
  }

  // Wait briefly for any rapid + / - clicks to finish.
  quantityUpdateTimers[lineID] = setTimeout(function () {
    delete quantityUpdateTimers[lineID];

    // Read the latest quantity from the input.
    cartItem.quantity = $input.val();

    updateCartItemQuantity(cartItem);
  }, 300);
});
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    updateCartItemQuantity(cartItem);
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      $('.warning').remove();
      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              
                refreshCart(cart).then(function () {
                  if ($.fancybox && $('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }
                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  } else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }

                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                      });
                    }
                  }
                });
             
            }
          });
        },
        error: XMLHttpRequest => {
          const response = eval(`(${XMLHttpRequest.responseText})`);
          $('.warning').remove();
          let warning;
          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            $addToCartForm.after(warning);
          }
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });
      return false;
    });
  }
});

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;

function getLatestCart() {
  return $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false
  });
}
function setCartUpdating(isUpdating) {
  const $message = $('[data-cart-reconciliation-message]');
  const $button = $('[data-minicart-checkout-button], [data-cart-checkout-button]');

  if (isUpdating) {
    $message.removeAttr('hidden');
    $button.prop('disabled', true).attr('aria-disabled', 'true');
  } else {
    $message.attr('hidden', 'hidden');
    $button.prop('disabled', false).removeAttr('aria-disabled');
  }
}